import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Drawer,
  Form,
  Input,
  InputNumber,
  InputRef,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Tabs,
  TabsProps,
  Tooltip,
  Upload,
} from "antd";
import React from "react";
import {
  CloseOutlined,
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useClient } from "../../Context/ClientContext";
import TextArea from "antd/es/input/TextArea";
import { notificationContext } from "../../Common/Routing/PageRoute";
import { handleInputFocus, Utils } from "../../../Utilities/Utils";
import { dayjs } from "../../../Utilities/dayjs";
import { AccountShort, ISelectGroup } from "../../../Types/CommonTypes";
import ItemsService, {
  ItemAdd_Type,
  BatchItemStatus,
  DiscountSalesType,
  Item_Nature,
  ItemStatus,
  ItemValuationMethodOption,
  IUnitRequest,
  IItemList,
} from "../../Services/ItemsService";
import UnitModel from "../ItemUnit/AddItemUnit";
import { CompanyGSTTypes } from "../../../Types/CommonConstants";
import EntryLevelKeys from "../../Common/EntryLevelKeys";
import DocumentPreview from "../../Common/DocumentPreview";
import ItemCategoryService from "../../Services/ItemCategoryService";
import AddCategoryItemsModel from "../ItemCategory/AddCategoryItemsModel";
import AddBatchItemsModal from "../ItemBatchAndSerial/AddBatchItemsModal";
import AddSerialNoModal from "../ItemBatchAndSerial/AddSerialNoModal";
import ItemLocationModel from "../ItemLocations/ItemLocationModel";
import { FC, useContext, useEffect, useRef, useState } from "react";
import { useUser } from "../../../Context/UserContext";
import { findUserOnlyOnePremission } from "../Users/Roles/UserSecurityFind";
import { useQuery } from "react-query";
import Items from "./ItemTable";
import { number } from "echarts";
import { useHotkey } from "../../Context/HotKeyContext";

interface iItemCategoryList {
  id: string;
  categoryName: string;
}

const AddItems: FC<{
  open: boolean;
  onCancel: any;
  id?: string;
  setTrigger?: any;
  setNewItem?: any;
  itemPage?: any;
  isServicesItem?: boolean;
  oldItem?: boolean;
}> = (props) => {
  const { showKeys } = useHotkey();
  const [form] = Form.useForm();
  const inputRef = useRef<InputRef>(null);
  const { currentClient, companySettings, updateCompanySettings } = useClient();
  const { getUser, accessSettings, clientSpecificRole } = useUser();
  const { openNotification } = useContext(notificationContext);
  const [props1, setProps1] = useState<any>(false);
  const [isGstEnabled, setIsGstEnabled] = useState<boolean>();
  const [defaultAccount, setDefaultAccount] = useState<any>();
  const [salesAccounts, setSalesAccounts] = useState<any[]>([]);
  const [itemAvailable, setItemAvailable] = useState<boolean>(false);
  const [modelLoading, setModelLoading] = useState<boolean>(false);
  const [checkServices, setCheckServices] = useState<boolean>(
    props?.isServicesItem ?? false
  );
  const [salesCheckbox, setSalesCheckbox] = useState<boolean>(true);
  const [purchaseCheckbox, setPurchaseCheckbox] = useState<any>(true);
  const [stockData, setStockData] = useState<any>({});
  const [purchaseAccounts, setPurchaseAccounts] = useState<any[]>([]);
  const [unitOptions, setUnitOptions] = useState<any[]>([]);
  const [searchUnit, setSearchUnit] = useState<string>(" ");
  const [openModel, setOpenModel] = useState<boolean>(false);
  const [uniType, setUnitType] = useState<any>();
  const [refFormVal, setRefFormVal] = useState<boolean>(false);
  const [disItemType, setDisItemType] = useState<boolean>(false);
  const [itemsList, setItemsList] = useState<IItemList[]>();
  const [isModelOpen, setIsModelOpen] = useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });

  const [addItmModal, setitmModel] = useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });
  const [trigger, setTrigger] = useState<boolean>(false);
  const [unitData, setUnitData] = useState<any>({});
  const [selectGSTId, setSelectGSTId] = useState<any>();
  const [addGstSetting, setAddGSTSetting] = useState<boolean>(false);
  const [deleteUploadId, setDeleteUploadId] = useState<string[]>([]);
  const [previewImage, setPreviewImage] = useState<{
    isBaseConvert: boolean;
    path: any;
    // uploadType: string;
  }>({ isBaseConvert: false, path: "" });
  const [itemCategoryList, setItemCategoryList] = useState<iItemCategoryList[]>(
    []
  );
  const [discountType, setDiscountType] = useState<DiscountSalesType>(
    DiscountSalesType.Percentage
  );
  const [addCatVal, setAddCatVal] = useState<any>();
  const [addNewLocation, setAddNewLocation] = useState<{
    id: string;
    name: string;
  }>({ id: "", name: "" });
  const [addUnitVal, setAddUnitVal] = useState<IUnitRequest>();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // const gstOption = companySettings?.setting?.gstDetails?.gst ?? [];
  const itemSetting = companySettings?.setting?.item;
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  const [openCatModel, setOpenCatModel] = useState<boolean>(false);
  const [locationDetail, setLocationdetail] = useState<any[]>([]);
  const [trackingType, setTrackingType] = useState<Item_Nature>(
    Item_Nature.Normal
  );
  const [batchData, setBatchData] = useState<any[]>([]);
  const [barCodeLoad, setBarCodeLoad] = useState(false);
  const [serialNoData, setSerialNoData] = useState<any[]>([]);
  const [batchOpnQty, setBatchOpnQty] = useState<number>();
  const [updateTimeSettingData, setUpdateTimeSettingData] = React.useState<{
    showItemCategory: boolean;
    showItemLocation: boolean;
    showItemGroup: boolean;
    showInventoryManagement: boolean;
    showBarCode: boolean;
    showMrp: boolean;
    showWholSalePrice: boolean;
    showBatchTracking: boolean;
    showSerialTracking: boolean;
  }>({
    showItemCategory: false,
    showItemLocation: false,
    showItemGroup: false,
    showInventoryManagement: false,
    showBarCode: false,
    showMrp: false,
    showWholSalePrice: false,
    showBatchTracking: false,
    showSerialTracking: false,
  });
  const [allBatchData, setAllBatchData] = React.useState<any>([]);
  const [allSerialData, setAllSerialData] = React.useState<any[]>([]);

  const handleTrackingType = (val: any) => {
    setTrackingType(val);
  };
  const handleItemNameChange = (value: any) => {
    let isAvailable = itemsList
      ?.filter((led) => led.id !== props.id)
      .some((led) => led.name.toLowerCase() === value.toLowerCase());
    setItemAvailable(isAvailable!);
  };

  const handleNullValue = (e: any) => {
    let fieldName = e?.target?.id.search("_")
      ? e?.target?.id.split("_").splice(1)
      : e?.target?.id;
    if (
      e.target.value === null ||
      e.target.value === undefined ||
      e.target.value === ""
    ) {
      form.setFieldValue(fieldName, 0);
    }
  };
  // console.log("loginUser", loginUser?.accessSettings?.voucherAccessList);

  // console.log("loginUser", accessSettings());
  // const handleInputFocus = (e: any) => {
  //   let val = Utils.getNumber(e?.target?.value);
  //   let fieldName = e?.target?.id.search("_")
  //     ? e?.target?.id.split("_").splice(1)
  //     : e?.target?.id;
  //   if (val === 0) {
  //     form.setFieldValue(fieldName, "");
  //   } else {
  //     e?.target?.select();
  //   }
  // };
  const stockOnChange = () => {
    let qty = Utils.getNumber(form.getFieldValue(["openingStock", "quantity"]));
    let price = Utils.getNumber(form.getFieldValue(["openingStock", "price"]));
    let totalAmount = Utils.getNumber(
      form.getFieldValue(["openingStock", "totalAmount"])
    );
    if (qty > 0 && price > 0) {
      form.setFieldValue(
        ["openingStock", "totalAmount"],
        Utils.getFormattedNumber(qty * price)
      );
    } else if (totalAmount > 0 && qty > 0) {
      form.setFieldValue(
        ["openingStock", "price"],
        Utils.getFormattedNumber(totalAmount / qty)
      );
    } else {
      form.setFieldValue(["openingStock", "totalAmount"], 0);
    }
  };

  const priceOnChange = () => {
    let qty = Utils.getNumber(form.getFieldValue(["openingStock", "quantity"]));
    let price = Utils.getNumber(form.getFieldValue(["openingStock", "price"]));

    if (qty > 0 && price > 0) {
      form.setFieldValue(
        ["openingStock", "totalAmount"],
        Utils.getFormattedNumber(qty * price)
      );
    } else {
      form.setFieldValue(["openingStock", "totalAmount"], 0);
    }
  };

  const totalAmountStock = () => {
    let totAmt = Utils.getNumber(
      form.getFieldValue(["openingStock", "totalAmount"])
    );
    let qty = Utils.getNumber(form.getFieldValue(["openingStock", "quantity"]));
    if (totAmt > 0 && qty > 0) {
      form.setFieldValue(
        ["openingStock", "price"],
        Utils.getFormattedNumber(totAmt / qty)
      );
    } else {
      form.setFieldValue(["openingStock", "price"], 0);
    }
  };

  console.log("props?.id", props?.oldItem);
  const batchndSNo =
    trackingType === Item_Nature.Batch
      ? batchOpnQty
      : allSerialData?.length ?? 0;
  console.log("batchOpnQtyyyyyy", batchOpnQty);

  useEffect(() => {
    if (batchOpnQty === 0 || batchOpnQty || allSerialData) {
      form.setFieldsValue({
        openingStock: {
          quantity: batchndSNo,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSerialData, batchOpnQty, form]);

  React.useEffect(() => {
    const getVal = form.getFieldsValue();
    setUnitType(getVal?.unit?.title);
    console.log("getVal", uniType);
    setRefFormVal(false);
  }, [refFormVal]);

  // get api Item Category
  useEffect(() => {
    const getCategoryNameList = async () => {
      await ItemCategoryService.getCategoryList(currentClient?.id)
        .then((res) => {
          if (res?.result?.items?.length > 0) {
            setItemCategoryList(
              res?.result?.items.map((x: any) => {
                return {
                  id: x.id,
                  categoryName: x.categoryName,
                };
              })
            );
          }
        })
        .catch((err) => {
          setItemCategoryList([]);
          console.error(err?.message);
        });
    };
    getCategoryNameList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getItemsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getItemsData = async () => {
    let res = await ItemsService?.getListItems(currentClient?.id!, 0, 0);
    if (res) {
      setItemsList(res?.items);
    }
  };

  // ------- Initial or Edit item Api --------
  useEffect(() => {
    const getItemData = async () => {
      setModelLoading(true);
      await ItemsService.getItem(currentClient?.id!, props?.id)
        .then((res) => {
          if (res?.status) {
            console.log("res.resulttt", res.result);
            const total = res?.result?.inventoryItem?.batchItem?.reduce(
              (acc: any, item: any) =>
                acc +
                (item.availableQty
                  ? item.availableQty
                  : item.openingQuantity || 0),
              0
            );
            setDisItemType(res?.result?.haveTransaction);
            setBatchOpnQty(total);
            setIsGstEnabled(
              currentClient?.gstType === CompanyGSTTypes.Regular ||
                (props.id && res.result?.inventoryItem?.taxRate?.id !== 0
                  ? res.result?.inventoryItem?.taxRate?.rate === 0 ||
                    res.result?.inventoryItem?.taxRate?.rate > 0
                  : false)
                ? true
                : false
            );

            setAllBatchData(res?.result?.inventoryItem?.batchItem);
            setAllSerialData(res?.result?.inventoryItem?.serialItem);
            setDefaultAccount(res?.result?.defaultAccount);
            const inv = res?.result?.inventoryItem;
            setTrackingType(inv?.trackingType);

            inv?.isService && setCheckServices(true);
            props?.id && setStockData(inv?.openingStock);
            if (props?.id) {
              inv?.purchaseItem
                ? setPurchaseCheckbox(true)
                : setPurchaseCheckbox(false);

              inv?.salesItem ? setSalesCheckbox(true) : setSalesCheckbox(false);
              setUpdateTimeSettingData({
                showItemCategory: inv?.itemCatgoryId
                  ? inv?.itemCatgoryId?.length > 0
                  : false,
                showItemLocation: inv?.location ?? false,
                showItemGroup: false,
                showInventoryManagement: false,
                showBarCode: inv?.barCode ?? false,
                showMrp: inv?.mrpDetails ?? false,
                showWholSalePrice: inv?.wholesaleDetails ?? false,
                showBatchTracking: inv?.trackingType === Item_Nature.Batch,
                showSerialTracking: inv?.trackingType === Item_Nature.Serial,
              });
            }

            // const parsedDate = dayjs(
            //   dayjs(inv?.openingStock?.date).format("DD/MM/YYYY"),
            //   "DD/MM/YYYY"
            // );
            setSelectGSTId({
              key: inv.taxRate?.name,
              value: inv.taxRate?.id,
              title: inv.taxRate?.rate,
              label: inv.taxRate?.name,
            });
            setDiscountType(
              props?.id
                ? inv?.salesItem?.discountSalesType
                : DiscountSalesType.Percentage
            );

            // {label: 'GST 1.5%', value: 12, key: 'GST 1.5%',

            form.setFieldsValue({
              ...inv,
              // trackingType:
              //   inv?.batchItem?.[0]?.trackingType ??
              //   inv?.serialItem?.[0]?.trackingType ??
              //   "",
              isService: props.id ? inv.isService : checkServices,
              isTaxable: props.id ? inv?.isTaxable : false,
              taxRate: props.id &&
                inv.taxRate?.id > 0 && {
                  key: inv.taxRate?.name,
                  value: inv.taxRate?.id,
                  title: inv.taxRate?.rate,
                  label: inv.taxRate?.name,
                },

              unit: props?.id && {
                label: inv?.unit?.name,
                value: inv?.unit?.id,
                title: inv?.unit?.unitType,
                shortName: inv?.unit?.shortName,
              },
              purchaseItem: {
                ...inv?.purchaseItem,
                price: Utils.getFormattedNumber(inv?.purchaseItem?.price),
              },
              salesItem: {
                ...inv?.salesItem,
                price: Utils.getFormattedNumber(inv?.salesItem?.price),
                discountSalesType: props?.id
                  ? inv?.salesItem?.discountSalesType
                  : DiscountSalesType.Percentage,
              },
              mrpDetails: {
                ...inv?.mrpDetails,
                price: Utils.getFormattedNumber(inv?.mrpDetails?.price),
              },
              wholesaleDetails: {
                ...inv?.wholesaleDetails,
                price: Utils.getFormattedNumber(inv?.wholesaleDetails?.price),
              },
              location: inv?.location,
              openingStock: {
                quantity: inv?.openingStock?.quantity ?? batchndSNo ?? 0,
                price: Utils.getFormattedNumber(inv?.openingStock?.price),
                totalAmount: Utils.getFormattedNumber(
                  inv?.openingStock?.totalAmount
                ),
                // date: parsedDate.isValid() ? parsedDate : null,
                date: inv?.openingStock?.date
                  ? dayjs(inv?.openingStock?.date)
                  : dayjs(currentClient?.financialYearBegin),
              },
            });

            if (res?.result?.salesAccounts) {
              let acc: ISelectGroup[] = res?.result?.salesAccounts?.map(
                (group: any) => ({
                  label: group.groupName,
                  options: group.accounts?.map((a: AccountShort) => ({
                    id: a.code,
                    label: a.name,
                    value: a.id,
                    title: group.group,
                  })),
                })
              );
              setSalesAccounts([...acc]);
            }

            if (res?.result?.purchaseAccounts) {
              let acc: ISelectGroup[] = res?.result?.purchaseAccounts?.map(
                (group: any) => ({
                  label: group.groupName,
                  options: group.accounts?.map((a: AccountShort) => ({
                    id: a.code,
                    label: a.name,
                    value: a.id,
                    title: group.group,
                  })),
                })
              );
              setPurchaseAccounts([...acc]);
            }
          } else {
            console.log(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
        })
        .finally(() => {
          setModelLoading(false);
        });
    };
    getItemData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, props?.id]);

  console.log("disItemType", disItemType);
  //-------- Unit API----------//
  useEffect(() => {
    ItemsService.getUnitsList(
      currentClient?.id!,
      0,
      15,
      "",
      "",
      searchUnit
    ).then((res: any) => {
      setUnitOptions(res?.result?.items);
      // console.log(res, "unitdata");
    });
  }, [currentClient?.id, searchUnit]);

  // console.log("unitOptions", unitOptions);

  // -------- Add or Edit Items Post API ---------
  const postItem = () => {
    form.validateFields().then(async (val: any) => {
      console.log("valll", val);

      if (salesCheckbox) {
        // if (
        //   currentClient?.gstType ===
        //     CompanyGSTTypes.Regular &&
        //   companySettings?.setting?.gstDetails?.gst?.length
        //     ? companySettings?.setting?.gstDetails?.gst.find(
        //         (x) => x.id === val?.taxRate?.value
        //       )
        //     : undefined
        // ) {
        // }
      }
      // if (
      //   currentClient?.gstType ===
      //     CompanyGSTTypes.Regular &&
      //   companySettings?.setting?.gstDetails?.gst?.length
      //     ? companySettings?.setting?.gstDetails?.gst.find(
      //         (x) => x.id === val?.taxRate?.value
      //       )
      //     : ""
      // ) {
      // }

      setSaveButtonLoading(true);
      console.log("val", val);

      let data = {
        ...val,
        name: val.name.trim(),
        // purchaseActive: purchaseCheckbox,
        // salesActive: salesCheckbox,
        hsnCode: val.isService ? null : val.hsnCode,
        sacCode: val.isService ? val.sacCode : null,
        itemStatus: ItemStatus.Active,
        itemAddType: props.oldItem ? ItemAdd_Type.Opening : ItemAdd_Type.New,
        purchaseItem: purchaseCheckbox
          ? {
              ...val.purchaseItem,
              isActive: purchaseCheckbox,
              type: 1,
              price: Utils.getNumber(val?.purchaseItem?.price),
            }
          : null,
        salesItem: salesCheckbox
          ? {
              ...val.salesItem,
              isActive: salesCheckbox,
              type: 0,
              price: Utils.getNumber(val?.salesItem?.price),
            }
          : null,
        taxRate: {
          id: val?.taxRate?.value ?? undefined,
          name: val?.taxRate?.key ?? undefined,
          rate: val?.taxRate?.title ?? undefined,
        },
        unit: val?.unit?.value && {
          id: val?.unit?.value,
          name: val?.unit?.label,
          unitType: val?.unit?.title,
          shortName: val?.unit?.shortName,
        },
        batchItem: allBatchData?.map((d: any) => {
          return {
            ...d,
            MFDate: dayjs(d.MFDate).toISOString() || null,
            expiryDate: dayjs(d.expiryDate).toISOString() || null,
            status: BatchItemStatus.Available,
          };
        }),
        serialItem: allSerialData?.map((d: any) => {
          return {
            ...d,
            warranty: dayjs(d.warranty).toISOString() || null,
          };
        }),
        openingStock: !checkServices
          ? {
              ...val.openingStock,
              quantity: val.openingStock
                ? val.openingStock?.quantity
                : stockData?.quantity
                ? stockData?.quantity
                : 0,
              price: Utils.getNumber(
                val.openingStock ? val.openingStock?.price : stockData?.price
              ),
              totalAmount: Utils.getNumber(
                val.openingStock
                  ? val.openingStock?.totalAmount
                  : stockData?.totalAmount
              ),

              date: val.openingStock
                ? dayjs(val.openingStock?.date).toISOString()
                : dayjs(stockData?.date).toISOString(),

              // location: val?.openingStock?.location?.value,
            }
          : null,
        deleteUploadId: deleteUploadId,
      };

      console.log("data", data);

      // const config = "multipart/form-data";
      // const formData = new FormData();

      // console.log("post data", data);
      //formData.values = data1;
      // val.attachments?.map((x: any) =>
      //   formData.append("file", x?.originFileObj)
      // );
      // const data = {
      //   ...data1,
      //   ...,
      // };

      // const x = {
      //   ...data1,
      //   ...val.attachments?.map((x: any) => formData.append("file", x)),
      // };

      // console.log("from data", formData);

      await ItemsService.PostItems(data, currentClient?.id!, props?.id)
        .then((res: any) => {
          if (res.result) {
            props?.setNewItem &&
              props?.setNewItem({
                data: res?.result,
                isSaved: true,
                isEdited: props?.id ? true : false,
              });
            setProps1(true);
            props?.setTrigger && props?.setTrigger((x: any) => !x);
            props?.onCancel();
            openNotification(
              "success",
              `Item ${
                props?.id ? "updated successfully." : "saved successfully."
              }`
            );
            setSaveButtonLoading(false);
          } else if (res?.message) {
            openNotification("error", res?.message);
            setSaveButtonLoading(false);
          }
        })
        .catch((ex: any) => {
          console.error(ex);
          openNotification("error", ex.message);
          setSaveButtonLoading(false);
        });

      // add gst in client Setting
      // if (addGstSetting && selectGSTId?.value) {
      //   const newGstDetail: IGstShort = {
      //     rate: selectGSTId?.title,
      //     name: selectGSTId?.label,
      //     id: selectGSTId?.value,
      //   };
      //   const updatedGstDetails = {
      //     gstDetails: {
      //       ...companySettings?.setting?.gstDetails!,
      //       gst:
      //         companySettings?.setting?.gstDetails?.gst!?.length > 0
      //           ? [...companySettings?.setting?.gstDetails?.gst!, newGstDetail]
      //           : [newGstDetail],
      //     },
      //   };

      //   console.log("updatedGstDetails", updatedGstDetails);

      //   // await updateCompanySettings!(
      //   //   SettingsSections.GstDetails,
      //   //   {
      //   //     ...companySettings,
      //   //     setting: {
      //   //       ...companySettings?.setting!,
      //   //       gstDetails: updatedGstDetails?.gstDetails!,
      //   //     },
      //   //   },
      //   //   updatedGstDetails
      //   // )
      //   //   .then((result: any) => {
      //   //     if (result?.status) {
      //   //       openNotification("success", "Setting updated successfully.");
      //   //       setSaveButtonLoading(false);
      //   //     } else {
      //   //       openNotification("error", "there is some error");
      //   //       setSaveButtonLoading(false);
      //   //     }
      //   //   })
      //   //   .catch((ex: any) => {
      //   //     setSaveButtonLoading(false);
      //   //     openNotification("error", ex.message);
      //   //   });
      // }
    });
  };
  EntryLevelKeys({
    save: () => postItem(),
    cancel: () => props.onCancel(),
  });

  useEffect(() => {
    getLocationList();
  }, []);

  const getLocationList = async () => {
    let res = await ItemsService.getItemLocationsList(currentClient?.id);
    if (res?.result) {
      setLocationdetail(res?.result);
      console.log("data", res);
    }
  };

  // const {
  //   data: locationList,
  //   isLoading,
  //   isError,
  // } = useLocationList(currentClient?.id);

  // const { data, refetch } = useQuery({
  //   queryKey: ["locations", currentClient],
  //   queryFn: () => ItemsService.getItemLocationsDropDownList(currentClient?.id),
  //   enabled: isModelOpen,
  // });

  useEffect(() => {
    if (addCatVal) {
      form.getFieldValue("itemCatgoryId")?.length > 0
        ? form.setFieldsValue({
            itemCatgoryId: [
              ...form.getFieldValue("itemCatgoryId"),
              addCatVal?.id,
            ],
          })
        : form.setFieldsValue({
            itemCatgoryId: [addCatVal?.id],
          });
      setItemCategoryList([
        ...itemCategoryList,
        {
          id: addCatVal?.id,
          categoryName: addCatVal?.name,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCatVal]);

  useEffect(() => {
    if (addNewLocation?.id) {
      form.setFieldValue(["location"], {
        value: addNewLocation.id,
        label: addNewLocation.name,
      });
      setLocationdetail([
        ...locationDetail,
        {
          id: addNewLocation.id,
          itemLocationName: addNewLocation.name,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addNewLocation, form]);

  useEffect(() => {
    // console.log("addUnitVal", addUnitVal);
    if (addUnitVal) {
      setUnitOptions((prev) => [...prev, addUnitVal]);
      form.setFieldsValue({
        unit: {
          value: addUnitVal.id,
          label: addUnitVal.name,
          title: addUnitVal.type,
          shortName: addUnitVal.shortName,
        },
      });
    }
  }, [addUnitVal, form]);

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Item",
      children: (
        <>
          {/* --------- For Purchases ---------*/}
          {trackingType !== Item_Nature.Batch && (
            <>
              <Divider
                orientation="left"
                orientationMargin="0"
                style={{ marginTop: "4px", marginBottom: "4px" }}
              >
                <p style={{ fontWeight: 600 }}>
                  Purchases Details
                  <Checkbox
                    style={{
                      // float: "left",
                      // padding: "6px 0px 12px 0px",
                      marginLeft: "10px",
                    }}
                    checked={purchaseCheckbox}
                    onChange={(e: any) => {
                      if (salesCheckbox) {
                        setPurchaseCheckbox(e.target.checked);
                      }
                    }}
                  />
                </p>
              </Divider>

              <Row gutter={14}>
                <Col sm={8}>
                  <Form.Item
                    htmlFor="price"
                    name={["purchaseItem", "price"]}
                    label="Price"
                    className="input-item"
                    // labelCol={{ sm: 8 }}
                    style={{ width: "100%" }}
                  >
                    <Input
                      disabled={!purchaseCheckbox}
                      addonAfter="INR"
                      onFocus={(e) => {
                        handleInputFocus(e, form);
                      }}
                      onBlur={(e) => {
                        form.setFieldValue(
                          ["purchaseItem", "price"],
                          Utils.getFormattedNumber(
                            Utils.getNumber(e.target.value)
                          )
                        );
                      }}
                      onKeyPress={(e: any) => {
                        if (!/\d|\./.test(e.key)) e.preventDefault();
                        if (e.key === "." && e.target.value.includes("."))
                          e.preventDefault();
                        if (
                          parseInt(
                            Utils.getNumber(e.target.value).toString()
                          ).toString().length > 9
                        )
                          e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col sm={8}>
                  <Form.Item
                    htmlFor="description"
                    label="Description"
                    name={["purchaseItem", "description"]}
                    className="input-item"
                    // labelCol={{ sm: 8 }}
                    style={{ width: "100%" }}
                    layout="vertical"
                  >
                    <TextArea
                      disabled={!purchaseCheckbox}
                      autoSize={{ minRows: 2, maxRows: 4 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          {/* --------- For sales ---------*/}
          <Divider
            orientation="left"
            orientationMargin="0"
            style={{ marginTop: "4px", marginBottom: "4px" }}
          >
            <span style={{ fontWeight: 600 }}>
              Sales Details
              <Checkbox
                style={{
                  // float: "left",
                  padding: "6px 0px 12px 0px",
                  marginLeft: "10px",
                }}
                checked={salesCheckbox}
                onChange={(e: any) => {
                  if (purchaseCheckbox) {
                    setSalesCheckbox(e.target.checked);
                  }
                }}
              />
            </span>
          </Divider>

          {/* --------- MRP sales ---------*/}
          {trackingType !== Item_Nature.Batch &&
            !checkServices &&
            (itemSetting?.isMrp || updateTimeSettingData.showMrp) && (
              <>
                <Divider
                  orientation="left"
                  orientationMargin="0"
                  style={{ marginTop: "4px", marginBottom: "4px" }}
                >
                  <p style={{ fontWeight: 500, fontSize: "14px" }}>
                    MRP Details
                  </p>
                </Divider>

                <Row gutter={14} justify="space-between">
                  <Col sm={8}>
                    <Form.Item
                      htmlFor="price"
                      label="MRP"
                      name={["mrpDetails", "price"]}
                      className="input-item"
                      style={{ width: "100%" }}
                    >
                      <Input
                        disabled={!salesCheckbox}
                        addonAfter="INR"
                        // precision={2}
                        onFocus={(e) => {
                          handleInputFocus(e, form);
                        }}
                        onBlur={(e) => {
                          form.setFieldValue(
                            ["mrpDetails", "price"],
                            Utils.getFormattedNumber(
                              Utils.getNumber(e.target.value)
                            )
                          );
                        }}
                        onChange={(e) => {
                          // Sales Discount & Wholesale Discount Befor Enter User
                          if (
                            form.getFieldValue(["mrpDetails", "disForSales"]) &&
                            form.getFieldValue([
                              "mrpDetails",
                              "disForWholeSale",
                            ])
                          ) {
                            form.setFieldValue(
                              ["salesItem", "price"],
                              Utils.getFormattedNumber(
                                (Utils.getNumber(e.target.value) *
                                  (100 -
                                    form.getFieldValue([
                                      "mrpDetails",
                                      "disForSales",
                                    ]))) /
                                  100
                              )
                            );
                            form.setFieldValue(
                              ["wholesaleDetails", "price"],
                              Utils.getFormattedNumber(
                                (Utils.getNumber(e.target.value) *
                                  (100 -
                                    form.getFieldValue([
                                      "mrpDetails",
                                      "disForWholeSale",
                                    ]))) /
                                  100
                              )
                            );
                          }
                          // Only Sales Discount Befor Enter
                          else if (
                            form.getFieldValue(["mrpDetails", "disForSales"])
                          ) {
                            form.setFieldValue(
                              ["salesItem", "price"],
                              Utils.getFormattedNumber(
                                (Utils.getNumber(e.target.value) *
                                  (100 -
                                    form.getFieldValue([
                                      "mrpDetails",
                                      "disForSales",
                                    ]))) /
                                  100
                              )
                            );
                          }
                          // user not discount enter
                          else {
                            form.setFieldValue(
                              ["salesItem", "price"],
                              Utils.getFormattedNumber(
                                Utils.getNumber(e.target.value)
                              )
                            );
                          }
                        }}
                        onKeyPress={(e: any) => {
                          if (!/\d|\./.test(e.key)) e.preventDefault();
                          if (e.key === "." && e.target.value.includes("."))
                            e.preventDefault();
                          if (
                            parseInt(
                              Utils.getNumber(e.target.value).toString()
                            ).toString().length > 9
                          )
                            e.preventDefault();
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col sm={8}>
                    <Form.Item
                      htmlFor="price"
                      label="Dis. on MRP for Sale (%)"
                      name={["mrpDetails", "disForSales"]}
                      className="input-item"
                      style={{ width: "100%" }}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        controls={false}
                        max={100}
                        precision={2}
                        disabled={!salesCheckbox}
                        onKeyPress={(e: any) => {
                          if (!/\d|\./.test(e.key)) e.preventDefault();
                          if (e.key === "." && e.target.value.includes("."))
                            e.preventDefault();
                        }}
                        onFocus={(e) => {
                          handleInputFocus(e, form);
                        }}
                        onBlur={(e) => {
                          handleNullValue(e);
                        }}
                        onChange={(e: any) => {
                          //  Mrp details before user enter
                          if (
                            Utils.getNumber(
                              form.getFieldValue(["mrpDetails", "price"])
                            )
                          ) {
                            form.setFieldValue(
                              ["salesItem", "price"],
                              Utils.getFormattedNumber(
                                Utils.getNumber(
                                  form.getFieldValue(["mrpDetails", "price"])
                                ) *
                                  ((100 - e) / 100)
                              )
                            );
                          }
                        }}
                        // percentToRs
                      />
                    </Form.Item>
                  </Col>

                  <Col sm={8}>
                    <Form.Item
                      htmlFor="price"
                      label="Dis. on MRP for Wholesale (%)"
                      name={["mrpDetails", "disForWholeSale"]}
                      className="input-item"
                      rules={[
                        {
                          validator: (_, value) => {
                            // console.log("value for wholesale discount", value);
                            if (
                              Utils.getNumber(value) <
                                Utils.getNumber(
                                  form.getFieldValue([
                                    "mrpDetails",
                                    "disForSales",
                                  ])
                                ) &&
                              salesCheckbox
                            ) {
                              return Promise.reject(
                                "Wholesale discount Cannot be less than Sale discount"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        controls={false}
                        max={100}
                        precision={2}
                        disabled={!salesCheckbox}
                        onKeyPress={(e: any) => {
                          if (!/\d|\./.test(e.key)) e.preventDefault();
                          if (e.key === "." && e.target.value.includes("."))
                            e.preventDefault();
                        }}
                        onFocus={(e) => {
                          handleInputFocus(e, form);
                        }}
                        onBlur={(e) => {
                          handleNullValue(e);
                        }}
                        onChange={(e: any) => {
                          console.log(
                            "data",
                            e,
                            form.getFieldValue(["mrpDetails", "price"])
                          );
                          //  Mrp details before user enter
                          if (e === null || e === undefined || e === 0) {
                            form.setFieldValue(
                              ["wholesaleDetails", "price"],
                              "0.00"
                            );
                          } else if (
                            Utils.getNumber(
                              form.getFieldValue(["mrpDetails", "price"])
                            )
                          ) {
                            form.setFieldValue(
                              ["wholesaleDetails", "price"],
                              Utils.getFormattedNumber(
                                Utils.getNumber(
                                  form.getFieldValue(["mrpDetails", "price"])
                                ) *
                                  ((100 - e) / 100)
                              )
                            );
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

          <Divider
            orientation="left"
            orientationMargin="0"
            style={{ marginTop: "4px", marginBottom: "4px" }}
          >
            <p style={{ fontWeight: 500, fontSize: "14px" }}>Sale</p>
          </Divider>

          <Row gutter={14}>
            {trackingType !== Item_Nature.Batch && (
              <>
                <Col sm={8}>
                  <Form.Item
                    htmlFor="price"
                    label="Price"
                    name={["salesItem", "price"]}
                    className="input-item"
                    // style={{ width: "100%" }}
                    //==========validations for Sale==========
                    rules={[
                      {
                        validator: (_, value) => {
                          // console.log("value", value);
                          if (
                            Utils.getNumber(value) >
                              Utils.getNumber(
                                form.getFieldValue(["mrpDetails", "price"])
                              ) &&
                            salesCheckbox &&
                            Utils.getNumber(
                              form.getFieldValue(["mrpDetails", "price"])
                            ) > 0
                          ) {
                            return Promise.reject(
                              "Cannot be more than MRP price"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      disabled={!salesCheckbox}
                      addonAfter="INR"
                      onFocus={(e) => {
                        handleInputFocus(e, form);
                      }}
                      onBlur={(e) => {
                        form.setFieldValue(
                          ["salesItem", "price"],
                          Utils.getFormattedNumber(
                            Utils.getNumber(e.target.value)
                          )
                        );
                        const mrpDisForSales = Utils.getNumber(
                          form.getFieldValue(["mrpDetails", "disForSales"])
                        );
                        // user fill Dis for Sales price , Mrp not fill - set Mrp price
                        if (
                          !Utils.getNumber(
                            form.getFieldValue(["mrpDetails", "price"])
                          ) &&
                          mrpDisForSales
                        ) {
                          const denominator = 100 - mrpDisForSales;

                          form.setFieldValue(
                            ["mrpDetails", "price"],
                            denominator === 0
                              ? 0.0
                              : Utils.getFormattedNumber(
                                  (100 * Utils.getNumber(e.target.value)) /
                                    (100 - mrpDisForSales)
                                )
                          );
                        }

                        // user fill Dis for Sales price , Mrp not fill - set Mrp price
                        if (
                          Utils.getNumber(
                            form.getFieldValue([
                              "mrpDetails",
                              "disForWholeSale",
                            ])
                          ) &&
                          mrpDisForSales
                        ) {
                          form.setFieldValue(
                            ["wholesaleDetails", "price"],
                            Utils.getFormattedNumber(
                              (Utils.getNumber(
                                form.getFieldValue(["mrpDetails", "price"])
                              ) *
                                (100 -
                                  form.getFieldValue([
                                    "mrpDetails",
                                    "disForWholeSale",
                                  ]))) /
                                100
                            )
                          );
                          // console.log(
                          //   "Mrp price",
                          //   form.getFieldValue(["mrpDetails", "price"])
                          // );
                        }
                      }}
                      onKeyPress={(e: any) => {
                        if (!/\d|\./.test(e.key)) e.preventDefault();
                        if (e.key === "." && e.target.value.includes("."))
                          e.preventDefault();
                        if (
                          parseInt(
                            Utils.getNumber(e.target.value).toString()
                          ).toString().length > 9
                        )
                          e.preventDefault();
                      }}
                      onChange={(e: any) => {
                        //  Mrp Details & Discount Befor user Enter
                        const mrpPrice = Utils.getNumber(
                          form.getFieldValue(["mrpDetails", "price"])
                        );
                        if (
                          mrpPrice &&
                          form.getFieldValue(["mrpDetails", "disForSales"])
                        ) {
                          // Mrp price > Sales price se = Set Discount Amout
                          if (mrpPrice >= Utils.getNumber(e.target.value)) {
                            form.setFieldValue(
                              ["mrpDetails", "disForSales"],
                              Utils.getNumber(
                                ((mrpPrice - Utils.getNumber(e.target.value)) /
                                  mrpPrice) *
                                  100
                              )
                            );
                          }
                          // Mrp price < Sales price se = Set Discount Amout
                          // else {
                          //   // console.log(
                          //   //   "Data",
                          //   //   "Mrp price < Sales price se = Set Discount Amout"
                          //   // );

                          //   form.setFieldValue(
                          //     ["mrpDetails", "price"],
                          //     Utils.getFormattedNumber(
                          //       (100 * Utils.getNumber(e.target.value)) /
                          //         (100 -
                          //           Utils.getNumber(
                          //             form.getFieldValue([
                          //               "mrpDetails",
                          //               "disForSales",
                          //             ])
                          //           ))
                          //     )
                          //   );
                          // }
                        }
                        // only mrp price given user - Done
                        else if (
                          Utils.getNumber(
                            form.getFieldValue(["mrpDetails", "price"])
                          )
                        ) {
                          console.log(
                            "only mrp price given user",
                            form.getFieldValue(["mrpDetails", "price"])
                          );
                          const x = Utils.getNumber(e.target.value);
                          form.setFieldValue(
                            ["mrpDetails", "price"],
                            Utils.getFormattedNumber(x)
                          );
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            <Col sm={8}>
              <Form.Item
                htmlFor="price"
                label="Dis. on Sales Price"
                name={["salesItem", "discountSalesPrice"]}
                className="input-item"
                rules={[
                  {
                    validator: (_, value) => {
                      if (
                        discountType === DiscountSalesType.Amount &&
                        Utils.getNumber(
                          form.getFieldValue(["salesItem", "price"])
                        ) <
                          Utils.getNumber(
                            form.getFieldValue([
                              "salesItem",
                              "discountSalesPrice",
                            ])
                          )
                      ) {
                        return Promise.reject("Cannot be more than Sale price");
                      } else if (
                        discountType === DiscountSalesType.Percentage &&
                        100 <
                          Utils.getNumber(
                            form.getFieldValue([
                              "salesItem",
                              "discountSalesPrice",
                            ])
                          )
                      ) {
                        return Promise.reject("Maximun discount 100%");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                  controls={false}
                  style={{ width: "100%" }}
                  disabled={!salesCheckbox}
                  min={0}
                  precision={2}
                  onFocus={(e) => {
                    handleInputFocus(e, form);
                  }}
                  onBlur={(e) => {
                    handleNullValue(e);
                  }}
                  onKeyPress={(e: any) => {
                    if (!/\d|\./.test(e.key)) e.preventDefault();
                    if (e.key === "." && e.target.value.includes("."))
                      e.preventDefault();
                  }}
                  max={
                    discountType === DiscountSalesType.Percentage
                      ? 100
                      : Utils.getNumber(
                          form.getFieldValue(["salesItem", "price"])
                        )
                  }
                />
              </Form.Item>
            </Col>

            <Col sm={8}>
              <Form.Item
                htmlFor="price"
                label="Discount Type"
                name={["salesItem", "discountSalesType"]}
                className="input-item"
                style={{ width: "100%" }}
              >
                <Select
                  disabled={!salesCheckbox}
                  options={[
                    {
                      label: "Percentage",
                      value: DiscountSalesType.Percentage,
                    },
                    { label: "Amount", value: DiscountSalesType.Amount },
                  ]}
                  onChange={(e) => setDiscountType(e)}
                />
              </Form.Item>
            </Col>

            {trackingType !== Item_Nature.Batch && (
              <>
                <Col sm={8}>
                  <Form.Item
                    htmlFor="description"
                    label="Description"
                    name={["salesItem", "description"]}
                    className="input-item"
                  >
                    <TextArea
                      disabled={!salesCheckbox}
                      autoSize={{ minRows: 2, maxRows: 4 }}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>

          {/* --------- Wholesale Price  ---------*/}
          {trackingType !== Item_Nature.Batch &&
            !checkServices &&
            (itemSetting?.wholesalePrice ||
              updateTimeSettingData.showWholSalePrice) && (
              <>
                <Divider
                  orientation="left"
                  orientationMargin="0"
                  style={{ marginTop: "4px", marginBottom: "4px" }}
                >
                  <p style={{ fontWeight: 500, fontSize: "14px" }}>Wholesale</p>
                </Divider>

                <Row gutter={14}>
                  <Col sm={8}>
                    <Form.Item
                      htmlFor="price"
                      label="Price"
                      name={["wholesaleDetails", "price"]}
                      className="input-item"
                      style={{ width: "100%" }}
                      rules={[
                        {
                          validator: (_, value) => {
                            console.log("value", value);
                            if (
                              Utils.getNumber(value) >
                                Utils.getNumber(
                                  form.getFieldValue(["salesItem", "price"])
                                ) &&
                              salesCheckbox
                            ) {
                              return Promise.reject(
                                "Cannot be more than Sale price"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        disabled={!salesCheckbox}
                        addonAfter="INR"
                        onFocus={(e) => {
                          handleInputFocus(e, form);
                        }}
                        onBlur={(e) => {
                          form.setFieldValue(
                            ["wholesaleDetails", "price"],
                            Utils.getFormattedNumber(
                              Utils.getNumber(e.target.value)
                            )
                          );
                        }}
                        onKeyPress={(e: any) => {
                          if (!/\d|\./.test(e.key)) e.preventDefault();
                          if (e.key === "." && e.target.value.includes("."))
                            e.preventDefault();
                          if (
                            parseInt(
                              Utils.getNumber(e.target.value).toString()
                            ).toString().length > 9
                          )
                            e.preventDefault();
                        }}
                        onChange={(e: any) => {
                          //  Mrp Details & Discount Befor user Enter
                          const salesPrice = Utils.getNumber(
                            form.getFieldValue(["salesItem", "price"])
                          );
                          const mrpPrice = Utils.getNumber(
                            form.getFieldValue(["mrpDetails", "price"])
                          );
                          if (
                            salesPrice &&
                            form.getFieldValue([
                              "mrpDetails",
                              "disForWholeSale",
                            ])
                          ) {
                            // Sales price > Wholesale price se = Set Discount Amout
                            if (salesPrice >= Utils.getNumber(e.target.value)) {
                              form.setFieldValue(
                                ["mrpDetails", "disForWholeSale"],
                                Utils.getNumber(
                                  ((mrpPrice -
                                    Utils.getNumber(e.target.value)) /
                                    mrpPrice) *
                                    100
                                )
                              );
                            }
                          }
                          // only mrp price given user - Done
                          // else if (
                          //   Utils.getNumber(
                          //     form.getFieldValue(["mrpDetails", "price"])
                          //   )
                          // ) {
                          //   console.log(
                          //     "only mrp price given user",
                          //     form.getFieldValue(["mrpDetails", "price"])
                          //   );
                          //   const x = Utils.getNumber(e.target.value);
                          //   form.setFieldValue(
                          //     ["mrpDetails", "price"],
                          //     Utils.getFormattedNumber(x)
                          //   );
                          // }
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col sm={8}>
                    <Form.Item
                      htmlFor="price"
                      label="Minimum Qty."
                      name={["wholesaleDetails", "minimumQty"]}
                      className="input-item"
                      rules={[
                        {
                          validator: (_, value) => {
                            if (
                              Utils.getNumber(
                                form.getFieldValue([
                                  "wholesaleDetails",
                                  "price",
                                ])
                              ) &&
                              !value &&
                              salesCheckbox
                            ) {
                              return Promise.reject(
                                "Wholesale minimum qty. is required"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        controls={false}
                        min={0}
                        precision={0}
                        disabled={!salesCheckbox}
                        onFocus={(e) => {
                          handleInputFocus(e, form);
                        }}
                        onBlur={(e) => {
                          handleNullValue(e);
                        }}
                        onKeyPress={(e: any) => {
                          if (!/\d/.test(e.key)) e.preventDefault();
                          // if (e.key === "." && e.target.value.includes("."))
                          //   e.preventDefault();
                        }}
                        // onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          <></>

          <Row justify="space-between">
            {/* --------- For Purchases ---------*/}
            {/* <Col sm={11}>
              <Row>
                <Col sm={8}></Col>
                <Col sm={2}>
                  <Checkbox
                    style={{
                      float: "left",
                      padding: "6px 0px 12px 0px",
                    }}
                    checked={purchaseCheckbox}
                    onChange={(e: any) => {
                      if (salesCheckbox) {
                        setPurchaseCheckbox(e.target.checked);
                      }
                    }}
                  />
                </Col>
                <Col sm={14} className="textStart">
                  <div className="pt-5"> For Purchases</div>
                </Col>
              </Row>
              <Form.Item
                htmlFor="price"
                name={["purchaseItem", "price"]}
                label="Purchase Price"
                className="input-item"
                labelCol={{ sm: 8 }}
                style={{ width: "100%" }}
              >
                <Input
                  disabled={!purchaseCheckbox}
                  addonAfter="INR"
                  onBlur={(e) => {
                    const allDetails = form.getFieldsValue();
                    form.setFieldsValue({
                      ...allDetails,
                      purchaseItem: {
                        ...allDetails?.purchaseItem,
                        price: Utils.getFormattedNumber(
                          e.target.value ? Utils.getNumber(e.target.value) : 0
                        ),
                      },
                    });
                  }}
                  onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                />
              </Form.Item>
              <Form.Item
                htmlFor="description"
                label="Description"
                name={["purchaseItem", "description"]}
                className="input-item"
                labelCol={{ sm: 8 }}
                style={{ width: "100%" }}
              >
                <TextArea disabled={!purchaseCheckbox} />
              </Form.Item>
            </Col> */}

            {/* --------- For sales ---------*/}

            {/* <Col sm={11}>
              <Row>
                <Col sm={8}></Col>
                <Col sm={2}>
                  <Checkbox
                    style={{
                      float: "left",
                      padding: "6px 0px 12px 0px",
                    }}
                    checked={salesCheckbox}
                    onChange={(e: any) => {
                      if (purchaseCheckbox) {
                        setSalesCheckbox(e.target.checked);
                      }
                    }}
                  />
                </Col>
                <Col sm={14} className="textStart">
                  <div className="pt-5"> For Sales</div>
                </Col>
              </Row>
              <Form.Item
                htmlFor="price"
                label="Sell Price"
                name={["salesItem", "price"]}
                className="input-item"
                labelCol={{ sm: 8 }}
                style={{ width: "100%" }}
              >
                <Input
                  disabled={!salesCheckbox}
                  addonAfter="INR"
                  onBlur={(e) => {
                    const allDetails = form.getFieldsValue();
                    form.setFieldsValue({
                      ...allDetails,
                      salesItem: {
                        ...allDetails?.salesItem,
                        price: Utils.getFormattedNumber(
                          e.target.value ? Utils.getNumber(e.target.value) : 0
                        ),
                      },
                    });
                  }}
                  onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                />
              </Form.Item>

            

              <Form.Item
                htmlFor="description"
                label="Description"
                name={["salesItem", "description"]}
                className="input-item"
                labelCol={{ sm: 8 }}
                style={{ width: "100%" }}
              >
                <TextArea disabled={!salesCheckbox} />
              </Form.Item>
            </Col> */}
          </Row>
          <Row>
            <Col sm={8} xs={24}>
              <Divider
                orientation="left"
                orientationMargin="0"
                className="dividertext"
                style={{ marginTop: "11px", marginBottom: "11px" }}
              >
                <p style={{ fontWeight: 600 }}>Upload</p>
              </Divider>
              <Form.Item
                // label="Add Image"
                name="attachments"
                valuePropName="fileList"
                getValueFromEvent={(e) => {
                  return e.fileList;
                }}
                // rules={[
                //   {
                //     required:
                //       data?.result?.ticketAttachments &&
                //       data?.result?.ticketAttachments?.length > 0
                //         ? false
                //         : true,
                //     message: "This field is required",
                //   },
                // ]}
              >
                {/* <CdUpload
                  maxCount={5}
                  accept={".png, .jpg, .jpeg, .pdf"}
                  onRemove={(e: any) => {
                    if (props?.id && e?.id) {
                      setDeleteUploadId([...deleteUploadId, e?.id]);
                    }
                  }}
                  onPreview={(e: any) => {
                    console.log("preview", e);
                    if (props?.id && e?.path) {
                      setPreviewImage({
                        isBaseConvert: false,
                        path: e,
                      });
                    } else if (e.type?.split("/")[0] === "image") {
                      setPreviewImage({
                        isBaseConvert: true,
                        path: e,
                      }); 
                    }
                  }}
                >
                  <CdButton
                    icon={<UploadOutlined />}
                    style={{ backgroundColor: "ButtonFace" }}
                    name="Upload"
                    type="default"
                  />
                 
                </CdUpload> */}
                <Upload
                  multiple
                  maxCount={5}
                  accept={".png, .jpg, .jpeg, .pdf"}
                  beforeUpload={(file) => {
                    if (file.size > 1024 * 1024) {
                      openNotification(
                        "error",
                        `${file.name} size is more than 1 MB`
                      );
                      return Upload.LIST_IGNORE;
                    }
                    let imgArray: string[] = [
                      "image/jpeg",
                      "image/jpg",
                      "image/png",
                      "application/pdf",
                    ];
                    if (!imgArray.some((type) => type === file.type)) {
                      openNotification(
                        "error",
                        `${file.name} has invalid file format`
                      );
                      return Upload.LIST_IGNORE;
                    }

                    return false;
                  }}
                  onRemove={(e: any) => {
                    if (props?.id && e?.id) {
                      setDeleteUploadId([...deleteUploadId, e?.id]);
                    }
                  }}
                  onPreview={(e: any) => {
                    // console.log("preview", e);
                    if (props?.id && e?.path) {
                      setPreviewImage({
                        isBaseConvert: false,
                        path: e,
                      });
                    } else if (e.type?.split("/")[0] === "image") {
                      setPreviewImage({
                        isBaseConvert: true,
                        path: e,
                      });
                    }
                  }}
                >
                  <Button
                    icon={<UploadOutlined />}
                    style={{ backgroundColor: "ButtonFace" }}
                  >
                    Upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  // eslint-disable-next-line no-lone-blocks
  if (!checkServices && (props?.id || props?.oldItem === true)) {
    items.push({
      key: "2",
      label: "Stock",
      children: (
        <>
          <Row
            style={{
              justifyContent: "space-between",
              paddingTop: "10px",
            }}
          >
            <Col sm={11} xs={24}>
              <Form.Item
                name={["openingStock", "quantity"]}
                label="Current Qty"
                htmlFor="quantity"
                className="input-item"
              >
                <InputNumber
                  className="itmvtch"
                  controls={false}
                  disabled={
                    props?.oldItem === true && trackingType === 0 ? false : true
                  }
                  precision={uniType === 3 ? 0 : 3}
                  step={uniType === 3 ? 1 : 0.001}
                  onChange={(e) => stockOnChange()}
                  // formatter={(value: any) => Utils.getInputNumberFormat(value)}
                  onFocus={(e) => handleInputFocus(e, form)}
                  onBlur={(e) => handleNullValue(e)}
                  onKeyPress={(e: any) => {
                    if (!/\d|\./.test(e.key)) e.preventDefault();
                    if (e.key === "." && e.target.value.includes("."))
                      e.preventDefault();
                  }}
                  addonAfter={
                    trackingType === Item_Nature.Batch ? (
                      <Button
                        icon={<PlusOutlined />}
                        style={{ border: "none" }}
                        onClick={() => {
                          setitmModel({
                            type: "batchItem",
                            param: { open: true },
                          });
                        }}
                      >
                        Batch
                      </Button>
                    ) : trackingType === Item_Nature.Serial ? (
                      <Button
                        style={{ border: "none" }}
                        icon={<PlusOutlined />}
                        onClick={() => {
                          setitmModel({
                            type: "serialNo",
                            param: { open: true },
                          });
                        }}
                      >
                        Serial No.
                      </Button>
                    ) : null
                  }
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            {props?.oldItem && (
              <>
                <Col sm={11} xs={24}>
                  <Form.Item
                    htmlFor="date"
                    label="As on"
                    name={["openingStock", "date"]}
                    className="input-item"
                  >
                    {/* <CbDatePicker
                      disabledDate={(current) =>
                        current < dayjs(currentClient?.financialYearBegin) ||
                        current > dayjs(currentClient?.financialYearBegin)
                      }
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      allowClear={false}
                    /> */}
                    <DatePicker
                      disabledDate={(current) =>
                        current < dayjs(currentClient?.financialYearBegin) ||
                        current > dayjs(currentClient?.financialYearBegin)
                      }
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      allowClear={false}
                    />
                  </Form.Item>
                </Col>

                {trackingType !== Item_Nature.Batch && (
                  <>
                    <Col sm={11} xs={24}>
                      <Form.Item
                        htmlFor="price"
                        label="At Price"
                        name={["openingStock", "price"]}
                        className="input-item"
                      >
                        <Input
                          addonAfter="INR"
                          onChange={() => priceOnChange()}
                          onFocus={(e) => handleInputFocus(e, form)}
                          onBlur={(e) => {
                            const allDetails = form.getFieldsValue();
                            form.setFieldsValue({
                              ...allDetails,
                              openingStock: {
                                ...allDetails?.openingStock,
                                price: Utils.getFormattedNumber(
                                  e.target.value
                                    ? Utils.getNumber(e.target.value)
                                    : 0
                                ),
                              },
                            });
                          }}
                          onKeyPress={(e: any) => {
                            if (!/\d|\./.test(e.key)) e.preventDefault();
                            if (e.key === "." && e.target.value.includes("."))
                              e.preventDefault();
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}

                {trackingType !== Item_Nature.Batch && (
                  <>
                    <Col sm={11} xs={24}>
                      <Form.Item
                        htmlFor="totalAmount"
                        name={["openingStock", "totalAmount"]}
                        label="Total Amount"
                        className="input-item"
                        rules={[
                          {
                            validator: async (_, value) => {
                              const qty = form.getFieldValue([
                                "openingStock",
                                "quantity",
                              ]);
                              if (!qty || qty === 0) {
                                throw new Error(
                                  "Please enter a valid Current Qty before Total Amount"
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          addonAfter="INR"
                          onChange={() => {
                            totalAmountStock();
                          }}
                          onFocus={(e) => handleInputFocus(e, form)}
                          onBlur={(e) => {
                            const allDetails = form.getFieldsValue();

                            form.setFieldsValue({
                              ...allDetails,
                              openingStock: {
                                ...allDetails?.openingStock,
                                totalAmount: Utils.getFormattedNumber(
                                  e.target.value
                                    ? Utils.getNumber(e.target.value)
                                    : 0
                                ),
                              },
                            });
                          }}
                          onKeyPress={(e: any) => {
                            if (!/\d|\./.test(e.key)) e.preventDefault();
                            if (e.key === "." && e.target.value.includes("."))
                              e.preventDefault();
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
              </>
            )}
          </Row>
          <Divider style={{ margin: "0px" }} />
        </>
      ),
    });
  }

  console.log(currentClient?.gstType);

  // const handleGSTValidation = () => {
  //   if (currentClient?.gstType === CompanyGSTTypes.Regular)
  //     if (gstOption.find((x) => x?.id === selectGSTId?.value)) {
  //       return <></>;
  //     } else if (selectGSTId?.value) {
  //       return (
  //         <Tag bordered={true} color="red" className="m-5">
  //           Selected GST Rate is not listed in Company's GST Settings hence the
  //           same will be added.
  //         </Tag>
  //       );
  //     }
  // };

  // useEffect(() => {
  //   if (
  //     currentClient?.gstType ===
  //       CompanyGSTTypes.Regular &&
  //     gstOption?.find((x) => x?.id === selectGSTId?.value)
  //   ) {
  //     setAddGSTSetting(false);
  //   } else {
  //     setAddGSTSetting(true);
  //   }
  // }, [companySettings, gstOption, selectGSTId]);

  // Get BarCode number----

  const getBarCode = async () => {
    setBarCodeLoad(true);
    let res = await ItemsService.getBarCode(currentClient?.id);
    if (res?.result) {
      form.setFieldsValue({
        barCode: res?.result,
      });
      setBarCodeLoad(false);
    } else {
      setBarCodeLoad(false);
      openNotification("error", res?.message);
    }
  };

  const suffix = (
    <Button
      onClick={getBarCode}
      loading={barCodeLoad}
      size="small"
      style={{ border: "none" }}
      type="primary"
    >
      Generate
    </Button>
  );

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 150); // Adjust delay if needed

    return () => clearTimeout(timer);
  }, []);

  const [qty, setQty] = useState<number>(1);
  const [price, setPrice] = useState<number>(100);

  const total = getTotal(qty, price);

  return (
    <>
      <Drawer
        maskClosable={false}
        open={props.open}
        title={!props?.id ? "Add Item" : "Edit Item"}
        width={850}
        // onCancel={() => props.onCancel()}
        // closable={props.onCancel}
        closable={false}
        extra={
          <Space>
            <CloseOutlined onClick={() => props.onCancel()} />
            {/* <CdCloseButton onClick={() => props.onCancel()} /> */}
          </Space>
        }
        // style={{ maxHeight: `calc(100% - 50px)`, overflowY: "auto" }}
        // centered
        //  <Space
        //     style={{
        //       display: "flex",
        //       justifyContent: "end",
        //       marginRight: 20,
        //     }}
        //   >
        //     <Button onClick={() => props.setOpenDrawer({})}>Cancel</Button>
        //     <Button
        //       onClick={() => saveLedger()}
        //       type="primary"
        //       loading={saveButtonLoading}
        //     >
        //       {props?.id === "" ? "Save" : "Update"}
        //     </Button>
        //   </Space>
        footer={
          <div style={{ marginTop: "0px" }}>
            <Space
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: 20,
              }}
            >
              {/* {salesCheckbox ? handleGSTValidation() : <></>} */}
              {/* <CbCancelButton
                onClick={() => {
                  form.resetFields();
                  props.onCancel();
                }}
              /> */}
              <Tooltip
                title={<p>ALT+C</p>}
                placement="topLeft"
                open={showKeys}
                style={{}}
              >
                <Button
                  onClick={() => {
                    form.resetFields();
                    props.onCancel();
                  }}
                >
                  Cancel
                </Button>
              </Tooltip>
              <Tooltip
                title={<p>ALT+S</p>}
                placement="topLeft"
                open={showKeys}
                style={{}}
              >
                <Button
                  type="primary"
                  onClick={() => postItem()}
                  loading={saveButtonLoading}
                  className="modelSaveButtonMargin"
                  // style={{marginLeft:"10px"}}
                >
                  {!props?.id ? "Save" : "Update"}
                </Button>
              </Tooltip>
            </Space>
          </div>
        }
        className="ledgerdrawerstyle"
      >
        {/* <Divider className="ca-model-css" /> */}
        <Spin indicator={antIcon} spinning={modelLoading}>
          <Form
            form={form}
            name="item"
            autoCapitalize="false"
            requiredMark={true}
            colon={false}
            labelAlign="left"
            // labelCol={{ xs: 7, sm: 8 }}
            // wrapperCol={{ xs: 16, sm: 16 }}
            // labelWrap={true}
            style={{ margin: "0px", padding: "0px" }}
            layout="vertical"
          >
            <Row gutter={14}>
              <Col sm={8} xs={24}>
                <Form.Item
                  htmlFor="name"
                  name="name"
                  label="Name"
                  rules={[
                    { required: true, message: "Item's name is required" },
                    {
                      pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]*$/,
                      message:
                        "Only alphanumeric with space and some special characters i.e. '_', '(', ')', '&', '-', '.' and ',' are allowed",
                    },
                    {
                      min: 3,
                      max: 50,
                      message:
                        "Length must be Minimum 3 or Maximum 50 characters long",
                    },
                    {
                      validator: (_) => {
                        if (itemAvailable) {
                          return Promise.reject("Name already exists.");
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                  className="input-item"
                >
                  <Input
                    ref={inputRef}
                    autoFocus={true}
                    placeholder="Please input item name"
                    onChange={(e: any) => handleItemNameChange(e.target?.value)}
                  />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  htmlFor="isService"
                  label="Item's Nature"
                  name="isService"
                  // valuePropName="checked"
                  className="inputBoxMb8 inputLabel33"
                >
                  <Radio.Group
                    disabled={
                      props?.isServicesItem || props?.isServicesItem === false
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      setCheckServices(e.target.value);
                      if (e.target.value) {
                        trackingType === Item_Nature.Batch &&
                          setTrackingType(Item_Nature.Normal);
                      } else {
                        const tType = form.getFieldValue("trackingType");
                        tType && setTrackingType(tType);
                      }
                      const allDetails = form.getFieldsValue();
                      // checkServices
                      //   ? form.setFieldsValue({
                      //       ...allDetails,
                      //       purchaseItem: {
                      //         ...allDetails?.purchaseItem,
                      //         account: {
                      //           label:
                      //             defaultAccount?.purchaseAccount?.product
                      //               ?.name,
                      //           value:
                      //             defaultAccount?.purchaseAccount?.product?.id,
                      //         },
                      //       },
                      //       salesItem: {
                      //         ...allDetails?.salesItem,
                      //         account: {
                      //           label:
                      //             defaultAccount?.salesAccount?.product?.name,
                      //           value:
                      //             defaultAccount?.salesAccount?.product?.id,
                      //         },
                      //       },
                      //     })
                      //   : form.setFieldsValue({
                      //       ...allDetails,
                      //       purchaseItem: {
                      //         ...allDetails?.purchaseItem,
                      //         account: {
                      //           label:
                      //             defaultAccount?.purchaseAccount?.service
                      //               ?.name,
                      //           value:
                      //             defaultAccount?.purchaseAccount?.service?.id,
                      //         },
                      //       },
                      //       salesItem: {
                      //         ...allDetails?.salesItem,
                      //         account: {
                      //           label:
                      //             defaultAccount?.salesAccount?.service?.name,
                      //           value:
                      //             defaultAccount?.salesAccount?.service?.id,
                      //         },
                      //       },
                      //     });
                    }}
                  >
                    <Radio value={false}>Goods</Radio>
                    <Radio value={true}>Services</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>

              <Col sm={8} xs={24}>
                <Form.Item
                  htmlFor="number"
                  label="Item Code"
                  name="number"
                  // className="input-item"
                  className="input-item"
                  rules={[{ required: true, message: "Item code is required" }]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Unit"
                  name="unit"
                  rules={[
                    {
                      required: checkServices ? false : true,
                      message: "Select an unit",
                    },
                  ]}
                  className="input-item"
                  // initialValue="S.elect Unit"
                >
                  <Select
                    showSearch
                    // labelInValue
                    optionFilterProp="children"
                    placeholder="Search unit"
                    allowClear
                    filterOption={false}
                    notFoundContent={null}
                    onSearch={(value: string) => setSearchUnit(value)}
                    // onClick={() =>
                    //   setSearchUnit({ ...searchParty, search: "" })
                    // }
                    // showArrow={false}
                    // onSearch={(value: string) => setSearchCustomer(value)}
                    // onSelect={(value: any) => {
                    //   CustomerSelect(value);
                    // }}
                    onChange={(e) => {
                      if (e) {
                        const selectedUnit = unitOptions.find(
                          (item: any) => item.id === e
                        );
                        form.setFieldsValue({
                          unit: {
                            value: selectedUnit?.id,
                            label: selectedUnit?.name,
                            shortName: selectedUnit?.shortName, // Add groupLabel
                            title: selectedUnit?.type, // Add title
                          },
                        });
                        setRefFormVal(true);
                      } else {
                        form.setFieldsValue({
                          unit: undefined,
                        });
                      }
                    }}
                    options={[
                      ...unitOptions?.map((value: any) => ({
                        value: value?.id,
                        label: value?.name + " " + `(${value?.shortName})`,
                        // title: value?.type,
                        // groupLabel: value?.shortName,
                      })),
                      {
                        value: "searchMore",
                        label: "Search for more...",
                        disabled: true,
                      },
                    ]}
                    dropdownRender={(unitOptions) => (
                      <>
                        {unitOptions}
                        {findUserOnlyOnePremission(
                          "Master.Item.Unit.Add",
                          clientSpecificRole(),
                          currentClient?.id!
                        ) && (
                          <>
                            <Divider style={{ margin: "5px 0px" }} />
                            <Button
                              icon={<PlusOutlined />}
                              style={{ width: "100%" }}
                              type="link"
                              onClick={() => {
                                setOpenModel(true);
                              }}
                            >
                              New Unit
                            </Button>
                          </>
                        )}
                      </>
                    )}
                  />
                </Form.Item>
              </Col>
              {(itemSetting?.maintainCategory ||
                updateTimeSettingData?.showItemCategory) && (
                <Col sm={8} xs={24}>
                  <Form.Item
                    htmlFor="ItemCatgoryId"
                    name="itemCatgoryId"
                    label="Category"
                    className="input-item"
                  >
                    <Select
                      allowClear
                      mode="multiple"
                      placeholder="Select category"
                      filterOption={(input, option) =>
                        (option?.label?.toString() ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      showSearch
                      onChange={(e: any) => {
                        console.log(e, "e");

                        // setSelectGSTId(e);
                      }}
                      options={itemCategoryList?.map((x: any) => ({
                        value: x?.id,
                        label: x?.categoryName,
                      }))}
                      dropdownRender={(unitOptions) => (
                        <>
                          {unitOptions}

                          {findUserOnlyOnePremission(
                            "Master.Item.Category.Add",
                            clientSpecificRole(),
                            currentClient?.id!
                          ) && (
                            <>
                              <Divider style={{ margin: "5px 0px" }} />
                              <Button
                                icon={<PlusOutlined />}
                                type="link"
                                style={{ width: "100%" }}
                                onClick={() => {
                                  setOpenCatModel(true);
                                }}
                              >
                                Add Category
                              </Button>
                            </>
                          )}
                        </>
                      )}
                    />
                  </Form.Item>
                </Col>
              )}
              {!checkServices &&
                (itemSetting?.maintainItemLocation ||
                  updateTimeSettingData?.showItemCategory) && (
                  <Col sm={8} xs={24}>
                    <Form.Item
                      htmlFor="location"
                      label="Location"
                      name="location"
                      className="input-item"
                    >
                      <Select
                        // labelInValue
                        style={{ marginBottom: "3px" }}
                        // loading={locDropdownLoading}
                        // onChange={handleLocation}
                        placeholder="Select location"
                        options={locationDetail?.map((l: any) => ({
                          value: l.id,
                          label: l.itemLocationName,
                        }))}
                        allowClear
                        dropdownRender={(itemsOption) => (
                          <>
                            {itemsOption}
                            {findUserOnlyOnePremission(
                              "Master.Item.Locations.Add",
                              clientSpecificRole(),
                              currentClient?.id!
                            ) && (
                              <>
                                <Divider
                                  style={{
                                    margin: "5px 0px",
                                  }}
                                />
                                <Button
                                  style={{ width: "100%" }}
                                  icon={<PlusOutlined />}
                                  type="link"
                                  onClick={() =>
                                    setIsModelOpen({
                                      type: "itemLocation",
                                      param: {
                                        open: true,
                                      },
                                    })
                                  }
                                >
                                  Add Location
                                </Button>
                              </>
                            )}
                          </>
                        )}
                      />
                    </Form.Item>
                  </Col>
                )}
              {/* {isGstEnabled && ( */}
              <Col sm={8} xs={24}>
                <Form.Item
                  htmlFor="isTaxable"
                  label="Tax Preference"
                  name="isTaxable"
                  // valuePropName="checked"
                  className="input-item"
                >
                  <Radio.Group>
                    <Radio value={true}>Inclusive</Radio>
                    <Radio value={false}>Exclusive</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {/* )} */}
              {/* {isGstEnabled && ( */}
              <Col sm={8} xs={24}>
                <Form.Item
                  htmlFor="taxRate"
                  name="taxRate"
                  label="GST Rate"
                  className="input-item"
                  rules={[
                    {
                      required:
                        currentClient?.gstType === CompanyGSTTypes.Regular ||
                        currentClient?.gstType === CompanyGSTTypes.Composition
                          ? true
                          : false,
                      message: "GST rate is required",
                    },
                  ]}
                >
                  <Select
                    allowClear
                    placeholder="Select GST Rate"
                    filterOption={(input, option) =>
                      (option?.label?.toString() ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    labelInValue={true}
                    onChange={(e: any) => {
                      // console.log(e, "e");
                      setSelectGSTId(e);
                    }}
                    options={companySettings?.gsts?.map((gst: any) => ({
                      key: gst.name,
                      value: gst.id,
                      title: gst.rate,
                      label: gst.name,
                    }))}
                  />
                </Form.Item>
              </Col>
              {/* )} */}
              {/* {isGstEnabled && ( */}
              <Col sm={8} xs={24}>
                {!checkServices ? (
                  <Form.Item
                    htmlFor="hsnCode"
                    name="hsnCode"
                    label="HSN Code"
                    className="input-item"
                    rules={[
                      {
                        required:
                          currentClient?.gstType === CompanyGSTTypes.Regular ||
                          currentClient?.gstType === CompanyGSTTypes.Composition
                            ? true
                            : false,
                        message: "HSN code is required",
                      },
                      {
                        pattern: /^(?!0+$)(\d{4}|\d{6}|\d{8})$/,
                        message:
                          "Enter valid HSN code with minimum 4 and maximum 8 digits",
                      },
                    ]}
                  >
                    <Input
                      placeholder="HSN code"
                      maxLength={8}
                      // controls={false}
                      // addonAfter={<SearchOutlined />}
                      onChange={(e) => {
                        const newValue = e.target.value.replace(/[^0-9]/g, "");
                        form.setFieldValue("hsnCode", newValue);
                      }}
                      // onKeyPress={(e) =>
                      //   !/[A-Za-z\s]/.test(e.key) && e.preventDefault()
                      // }
                    />
                  </Form.Item>
                ) : (
                  <Form.Item
                    htmlFor="sacCode"
                    name="sacCode"
                    label="SAC Code"
                    className="input-item"
                    rules={[
                      {
                        required:
                          currentClient?.gstType === CompanyGSTTypes.Regular ||
                          currentClient?.gstType === CompanyGSTTypes.Composition
                            ? true
                            : false,
                        message: "SAC code is required",
                      },
                      {
                        pattern: /^(?!0+$)(\d{4}|\d{6})$/,
                        message:
                          "Enter valid SAC code with minimum 4 and maximum 6 digits",
                      },
                    ]}
                  >
                    <Input
                      placeholder="SAC code"
                      maxLength={6}
                      // controls={false}
                      onChange={(e) => {
                        const newValue = e.target.value.replace(/[^0-9]/g, "");
                        form.setFieldValue("sacCode", newValue);
                      }}
                    />
                  </Form.Item>
                )}
              </Col>
              {/* )} */}

              {!checkServices &&
                (itemSetting?.isBarcode ||
                  updateTimeSettingData?.showBarCode) && (
                  <Col sm={8} xs={24}>
                    <Form.Item
                      htmlFor="barCode"
                      name="barCode"
                      label="Barcode"
                      className="input-item"
                    >
                      <Input suffix={suffix} />
                    </Form.Item>
                  </Col>
                )}
              {!checkServices && itemSetting?.inventoryManage && (
                <Col sm={8} xs={24}>
                  <Form.Item name="valuationMethod" label="Valuation Method">
                    <Select options={ItemValuationMethodOption} />
                  </Form.Item>
                </Col>
              )}
              {!checkServices &&
                (itemSetting?.batchTracking ||
                  itemSetting?.serialTracking ||
                  updateTimeSettingData?.showBatchTracking ||
                  updateTimeSettingData?.showSerialTracking) && (
                  <Col sm={8} xs={24}>
                    <Form.Item name="trackingType" label="Item's Type">
                      <Select
                        disabled={disItemType === true ? true : false}
                        options={[
                          {
                            label: "Normal",
                            value: Item_Nature.Normal,
                            title: "",
                          },
                          {
                            label: "Batch",
                            value: Item_Nature.Batch,
                            title: "",
                          },
                          {
                            label: "Serial",
                            value: Item_Nature.Serial,
                            title: "",
                          },
                        ]}
                        onChange={handleTrackingType}
                      />
                    </Form.Item>
                  </Col>
                )}
            </Row>

            <Divider style={{ margin: "0px" }} />

            {/*  -------- Tab Item & Stock --------- */}
            <Tabs
              centered
              defaultActiveKey="1"
              size="small"
              className="ca-tab-addItem"
              items={items}
            />
          </Form>
        </Spin>
        {openModel && (
          <UnitModel
            open={openModel}
            onCancel={() => setOpenModel(false)}
            setTrigger={setTrigger}
            data={unitData}
            setAddUnitVal={setAddUnitVal}
          />
        )}
        {previewImage.path && (
          <DocumentPreview
            open={true}
            onCancel={() =>
              setPreviewImage({
                path: "",
                isBaseConvert: false,
                // uploadType: "",
              })
            }
            documentDetails={previewImage}
          />
        )}
        {/* {} */}
        {props1 && <Items itemPage={props.itemPage} trigger={props1} />}
        {openCatModel && (
          <AddCategoryItemsModel
            open={true}
            onCancel={() => setOpenCatModel(false)}
            setTrigger={setTrigger}
            // editData={editCategoryData}
            setAddCatVal={setAddCatVal}
          />
        )}
        {addItmModal.type === "addLoaction" && (
          <ItemLocationModel
            open={true}
            onCancel={() => setitmModel({ type: "", param: "" })}
            setTrigger={setTrigger}
            setAddNewLocation={setAddNewLocation}
          />
        )}
        {addItmModal.type === "batchItem" && (
          <AddBatchItemsModal
            open={addItmModal?.param.open}
            onCancel={() => setitmModel({ type: "", param: "" })}
            setBatchData={setBatchData}
            id={props?.id}
            batchData={batchData}
            setBatchOpnQty={setBatchOpnQty}
            batchOpnQty={batchOpnQty}
            allBatchData={allBatchData}
            setAllBatchData={setAllBatchData}
            oldItem={props?.oldItem}
          />
        )}

        {addItmModal.type === "serialNo" && (
          <AddSerialNoModal
            open={addItmModal?.param.open}
            onCancel={() => setitmModel({ type: "", param: "" })}
            setSerialNoData={setSerialNoData}
            id={props?.id}
            serialNoData={serialNoData}
            allSerialData={allSerialData}
            setAllSerialData={setAllSerialData}
          />
        )}
        {isModelOpen.type === "itemLocation" && (
          <ItemLocationModel
            open={isModelOpen?.param.open}
            onCancel={() => setIsModelOpen({ type: "", param: "" })}
            setTrigger={() => {}}
            setAddNewLocation={setAddNewLocation}
          />
        )}
      </Drawer>
    </>
  );
};

export default AddItems;

export const useLocationList = (companyId: string | undefined) => {
  return useQuery({
    queryKey: ["locations", companyId],
    queryFn: () => ItemsService.getItemLocationsDropDownList(companyId),
    enabled: !!companyId,
    staleTime: Infinity,
  });
};

export const getTotal = (qty: number, price: number): number => qty * price;
